import type { LocalFile } from '@frontend/api-types';
import { Clickable, Icon, Text, XStack, YStack } from '@frontend/web-react';

export const FilePreview = ({
  file,
  onClick,
  onRemove,
}: {
  file: LocalFile;
  onClick?: () => void;
  onRemove?: () => void;
}) => (
  // eslint-disable-next-line tailwindcss/no-arbitrary-value
  <Clickable className="w-[150px] flex-row rounded-lg" enableHoverEffect key={file.url} onClick={onClick}>
    <XStack
      className="relative items-center border-borderPrimary rounded-lg border-1 gap-sm p-sm"
      key={file.url}
      onClick={onClick}
    >
      {onRemove ? (
        <YStack
          // eslint-disable-next-line tailwindcss/no-arbitrary-value,tailwindcss/no-custom-classname
          className="bg-trueWhite p-px absolute right-[-4px] top-[-4px] cursor-pointer rounded-full"
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
        >
          <YStack className="bg-neutral-950 rounded-xl p-xs">
            <Icon className="text-trueWhite" color="white" name="IconX" size={10} />
          </YStack>
        </YStack>
      ) : null}
      <Icon name="IconFile" size={20} />
      <YStack>
        <Text type="h6">{file.type?.split('/')[1]?.toUpperCase()}</Text>
        <Text color="secondary" type="caption">
          {file.type}
        </Text>
      </YStack>
    </XStack>
  </Clickable>
);
